import { render, staticRenderFns } from "./ADataTableSimple.vue?vue&type=template&id=4d8377da&"
import script from "./ADataTableSimple.vue?vue&type=script&lang=js&"
export * from "./ADataTableSimple.vue?vue&type=script&lang=js&"
import style0 from "./ADataTableSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports